import Vue from 'vue'
import RbDynamicSwiperSlide from '@/elements/smart-container/dynamic-swiper-slide'
export default Vue.extend({
  name: 'RbCrosslinksRenderer',
  functional: true,
  props: {
    categoryNames: {
      type: Array,
      default: () => [],
    },
    isShortcode: {
      type: Function,
      default: (label) => label,
    },
    sanitizeShortcode: {
      type: Function,
      default: (label) => label,
    },
    hasSwiper: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  render(h, context) {
    const { isShortcode, sanitizeShortcode, hasSwiper, isMobile } = context.props
    const slots = (context?.slots().default || [])?.filter((slot) => !!slot.tag) || []
    const categoryNames = context.props.categoryNames
    slots.forEach((slot) => {
      const label = slot.componentOptions?.propsData?.label
      if (slot.componentOptions) {
        slot.componentOptions.propsData.hasSwiper = hasSwiper
      }
      if (!isShortcode(label)) {
        return
      }
      const sanitizedShortcode = sanitizeShortcode(label)
      const crosslink = categoryNames.find(
        (crosslink) => crosslink.categoryName === sanitizedShortcode
      )
      if (crosslink) {
        slot.componentOptions.propsData.label = crosslink.label
        slot.componentOptions.propsData.href = crosslink.href
        slot.componentOptions.propsData.category = crosslink.categoryName
      }
    })

    const hasImage = slots.some((slot) => {
      const { image, imageDesktop, imageMobile, imageTablet } = slot.componentOptions?.propsData
      return image || imageDesktop || imageMobile || imageTablet
    })
    if (hasSwiper) {
      const findIndexActive = slots.findIndex((slot) => {
        if (slot.componentOptions) {
          const dataType = document.getElementById('pageType')?.value ?? ''
          return slot.componentOptions.propsData?.category === dataType
        }
      })
      const initialSlide = findIndexActive !== -1 ? findIndexActive : 0
      const wrapperSlots = slots.map((s, i) =>
        h(
          RbDynamicSwiperSlide,
          {
            props: {
              index: i,
            },
          },
          slots
        )
      )
      return h(
        'swiper',
        {
          class: {
            'rb-crosslinks-wrapper': true,
            'rb-crosslinks-wrapper--with-images': hasImage,
          },
          props: {
            navigation: true,
            initialSlide,
            slideToCenter: isMobile && initialSlide !== 0 ? initialSlide : false,
            config: {
              spaceBetween: hasImage ? 8 : 24,
              centeredSlides: false,
              slidesPerView: 'auto',
              freeMode: isMobile,
              freeModeSticky: !isMobile,
              loop: false,
              noSwiping: true,
              touchStartPreventDefault: false,
              allowTouchMove: isMobile,
              grabCursor: false,
            },
          },
        },
        [
          wrapperSlots,
          h('span', {
            class: 'common__icon common__icon--carousel-caret-right--light',
            slot: 'navigationnext',
          }),
          h('span', {
            class: 'common__icon common__icon--carousel-caret-left--light',
            slot: 'navigationprev',
          }),
        ]
      )
    }

    if (categoryNames.length === 0) {
      return h(
        'div',
        {
          class: 'rb-crosslinks-wrapper',
        },
        slots
      )
    }
    return h(
      'div',
      {
        class: {
          'rb-crosslinks-wrapper': true,
          'rb-crosslinks-wrapper--with-images': hasImage,
        },
      },
      [slots]
    )
  },
})
